import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {

  constructor(
    private activeModal: NgbActiveModal,
    private modalService : NgbModal
  ) { }

  ngOnInit() {
  }

  
  closeDialog() {
    this.activeModal.close();
  }
  closeAllDialog() {
    this.modalService.dismissAll();
  }

}
